import React from "react";
import { fmt } from "../lib/framing";

const KIND_COLOR = {
  glass: "#7DD3FC",
  spacer: "#CBD5E1",
  mat: "#E7D3A1",
  art: "#FCA5A5",
  backing: "#9CA3AF",
};

export const CrossSection = ({ r, unit }) => {
  if (!r || !r.depth_calc) return null;
  const layers = r.depth_layers || [];
  const total = r.total_depth || 0;
  const rebate = r.rebate_depth || 0;
  const maxD = Math.max(total, rebate, 0.0001);
  const fits = r.depth_fits;

  let cursor = 0;

  return (
    <div data-testid="cross-section" className="rounded-xl border border-border bg-card p-5">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="font-heading text-base font-bold">Frame layer cross-section</h2>
        <span
          data-testid="depth-fit-badge"
          className={`rounded-full px-2.5 py-1 text-xs font-semibold ${
            rebate <= 0 ? "bg-slate-100 text-slate-500" : fits ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-red-600"
          }`}
        >
          {rebate <= 0 ? "No rebate depth set" : fits ? "Fits the rebate" : "Exceeds rebate!"}
        </span>
      </div>

      <div className="flex gap-3">
        <div className="flex w-9 shrink-0 flex-col justify-between py-1 text-right font-mono text-[11px] text-muted-foreground">
          <span>front</span>
          <span>back</span>
        </div>
        <svg viewBox={`0 0 100 100`} className="flex-1 rounded-md" preserveAspectRatio="none" style={{ height: 240 }}>
          {layers.map((l, i) => {
            const h = (l.depth / maxD) * 100;
            const y = cursor;
            cursor += h;
            return (
              <rect key={i} x={0} y={y} width={100} height={Math.max(h, 0.4)} fill={KIND_COLOR[l.kind] || "#e5e7eb"} stroke="#334155" strokeWidth={0.15} />
            );
          })}
          {/* rebate depth marker */}
          {rebate > 0 && (
            <line x1={0} y1={(rebate / maxD) * 100} x2={100} y2={(rebate / maxD) * 100} stroke={fits ? "#059669" : "#DC2626"} strokeWidth={0.6} strokeDasharray="2 1.2" />
          )}
        </svg>
      </div>

      {/* legend */}
      <ul className="mt-3 space-y-1.5">
        {layers.map((l, i) => (
          <li key={i} data-testid={`depth-layer-${i}`} className="flex items-center justify-between text-sm">
            <span className="flex items-center gap-2 text-muted-foreground">
              <span className="inline-block h-3 w-3 rounded-sm" style={{ background: KIND_COLOR[l.kind] || "#e5e7eb" }} />
              {l.name}
            </span>
            <span className="font-mono text-slate-900">{fmt(l.depth, unit)} {unit}</span>
          </li>
        ))}
        <li className="flex items-center justify-between border-t border-border pt-2 text-sm font-semibold">
          <span>Total stack depth</span>
          <span data-testid="total-depth" className={`font-mono ${rebate > 0 && !fits ? "text-red-600" : "text-primary"}`}>
            {fmt(total, unit)} {unit}
          </span>
        </li>
        {rebate > 0 && (
          <li className="flex items-center justify-between text-sm text-muted-foreground">
            <span>Rebate depth available</span>
            <span className="font-mono">{fmt(rebate, unit)} {unit}</span>
          </li>
        )}
      </ul>
    </div>
  );
};
